import React, {useEffect, useState} from 'react';
import {DatePicker, Select} from "antd";

import {Column} from "@ant-design/plots";

import {API_PATH} from "../../components/const";
import dayjs from "dayjs";
import {each, groupBy} from "@antv/util";
import axios from "axios";
import {toast} from "react-toastify";

const {RangePicker} = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const DailyAnalyticsComparasion = () => {
    const moment = require('moment')
    const [time, setTime] = useState(new Date());
    const [month, setMonth] = useState(time.getMonth());
    const [year, setYear] = useState(time.getFullYear());
    const [offices, setOffices] = useState([]);
    const [data, setData] = useState([]);
    const [companies, setCompanies] = useState([])
    const [date1, setDate1] = useState(time?.getFullYear() + "-" + Number(month + 1) + "-" + 1)
    const [date2, setDate2] = useState(moment().endOf('month').format('YYYY-MM-DD'))
    const [parents, setParents] = useState([])

    const getParentBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/sections/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": 			"Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setParents(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
                asyncFetch(localStorage.getItem("com3data")?.split(',').map(Number))
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getBuildingFilter = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    function onChange(date, dateString) {
        if (dateString[0].length !== 0) {
            setDate1(dateString[0])
            setDate2(dateString[1])
            axios.post(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/visitor-demographics/age-sex-distribution/branches?start_date_str=" + dateString[0] + "&end_date_str=" + dateString[1],
                companies,
                {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((json) => {
                        setData(json?.data?.map(item => {
                            return {
                                ...item,
                                sex: item?.sex === "male" ? "Мужской" : "Женский",
                            }
                        }))
                    }
                )
                .catch(() => {
                    // toast.error("No data")
                });
        } else (
            asyncFetch()
        )
    }

    const asyncFetch = (data) => {
        axios.post(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/visitor-demographics/age-sex-distribution/branches?start_date_str=" + date1 + "&end_date_str=" + date2, data?.length > 0 ? data : companies, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then((json) => {
                    setData(json?.data?.map(item => {
                        return {
                            ...item,
                            sex: item?.sex === "male" ? "Мужской" : "Женский",
                        }
                    }))
                }
            )
            .catch(() => {
                // toast.error("No data")
            });

    };

    const annotations = [];
    each(groupBy(data, 'age_range'), (values, k) => {
        const value = values.reduce((a, b) => a + b.value, 0);
        annotations.push({
            type: 'text',
            position: [k, value],
            content: `${value}`,
            style: {
                textAlign: 'center',
                fontSize: 14,
                fill: '#FFFFFF',
                zIndex: 9999999,

            },
            offsetY: -15,
        });
    });
    const config = {
        data,
        isStack: true,
        xField: 'ageRange',
        yField: 'count',
        seriesField: 'sex',
        isGroup: true,
        groupField: 'branch_name',
        color: [ '#FC53F5', '#5664D2', '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],

        xAxis: {
            label: {
                style: {
                    fill: "#fff",
                },
            },
        },
        yAxis: {
            count: {
                label: {
                    style: {
                        fill: "#fff",
                    },
                },
            },
            value: {
                label: {
                    style: {
                        fill: "#fff",
                    },
                },
            },
        },
        style: {fill: '#000'},
        geometryOptions: [
            {
                geometry: "line",
                color: ["#000", "#000"],
                seriesField: "type",
            },
            {
                geometry: "line",
                color: "#000",
                seriesField: "type",
            },
        ],
        label: {
            position: 'middle',
            style: {
                fontSize: 14,
                textAlign: 'center',
            },
            layout: [
                {
                    type: 'interval-adjust-position',
                },
                {
                    type: 'interval-hide-overlap',
                },
                {
                    type: 'adjust-color',
                },
            ],
        },
        annotations,
    };
    useEffect(() => {
        // asyncFetch()
        getBuilding()
        getParentBuilding()
        setCompanies(localStorage.getItem("com3data")?.split(',').map(Number))

    }, []);
    return (
        <div className="visitor visitor-box ">
            <div className="chart-box">
                <div className="visitor-title">
                    <h1><span>
                    Ежедневная аналитика по возрастам
                </span>
                        <div className="d-flex align-items-center my-multi-select">
                            <div className="inputs-box mr-16 remove-back-select" >
                                <Select
                                    showSearch
                                    placeholder="Выберите раздел"
                                    optionFilterProp="children"
                                    className="w-100"
                                    onSearch={getParentBuilding}
                                    onChange={(e) => getBuildingFilter(e)}
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    options={parents?.map((item) => {
                                        return {
                                            value: item.id,
                                            label:
                                            item?.branch_title
                                        };
                                    })}
                                />
                            </div>

                            <div className="inputs-box mb-0 mr-16">
                                <Select
                                    showSearch
                                    mode="multiple"
                                    placeholder="Выберите филиал"
                                    optionFilterProp="children"
                                    className="w-100  "
                                    defaultValue={localStorage.getItem("com3data")?.length > 0 ? localStorage.getItem("com3data")?.split(',').map(Number) : []}
                                    onSearch={getBuilding}
                                    onChange={(e) => {
                                        setCompanies(e)
                                        localStorage.setItem("com3data", e)
                                    }}
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    options={offices?.map((item) => {
                                        return {
                                            value: item.id,
                                            label:
                                            item?.branch_title
                                        };
                                    })}
                                />
                            </div>
                            <button style={{fontSize: "14px"}}
                                    onClick={asyncFetch}
                                    className="mr-16 mt-2 add-btn">Сравнивать
                            </button>
                            <div>
                                <RangePicker
                                    placeholder={["Дата начала", "Дата окончания"]}
                                    defaultValue={[dayjs(moment().startOf('month').format('YYYY-MM-DD'), dateFormat), dayjs(moment().endOf('month').format('YYYY-MM-DD'), dateFormat)]}

                                    format={dateFormat}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                    </h1>
                </div>
                <Column {...config} />
            </div>
        </div>
    );
};

export default DailyAnalyticsComparasion;